import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

export default function CardBody({
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <div className={cn(styles.body, className)} {...htmlProps}>
      {children}
    </div>
  );
}
